import { useEffect, useState } from "react";
import PlansPanel from "@/components/billing/PlansPanel";

// Global PAYG top-up gate. Listens for the `mist:topup-required` event emitted
// by the axios interceptor on a 402 top_up_required (casual credits depleted)
// and surfaces the Stripe checkout PlansPanel so the user can buy more credits.
// Purely additive overlay — does not alter the frozen shell layout or nav.
export default function TopUpGate() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onTopup = () => setOpen(true);
    window.addEventListener("mist:topup-required", onTopup);
    return () => window.removeEventListener("mist:topup-required", onTopup);
  }, []);

  if (!open) return null;
  return (
    <div className="absolute inset-0 z-[60]" data-testid="topup-gate">
      <PlansPanel onBack={() => setOpen(false)} />
    </div>
  );
}
